module.exports = __webpack_public_path__ + "media/images/newseye_logo_small-41fb278a98ddd4e4f40c4ab78e909144.png";